const CURRENCY_SYMBOLS = {
  USD: "$",
  GBP: "£",
  EUR: "€",
  CAD: "$",
  AUD: "$",
  INR: "₹",
  JPY: "¥",
};

export const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "$";
  const code = String(currencyCode).trim().toUpperCase();
  return CURRENCY_SYMBOLS[code] || "$";
};

export const formatPriceWithCurrency = (amount, currencyCode) => {
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${Number(amount || 0).toFixed(2)}`;
};
